import { isNotFound, Link } from '@tanstack/react-router';
import { usePortalContext } from '@/lib/use-portal-context';
import { DivWithPrimaryColorVariable } from './div-with-primary-color-variable';
import { usePortalCampaignQuery } from '@/lib/queries';
import { Button } from '@worldcoo/ui/components/button';
import { useTranslation } from '@/lib/i18n';
import { Gradient } from '@worldcoo/ui/custom/gradient';
import { Suspense } from 'react';
import { Spinner } from '@worldcoo/ui/components/spinner';

export function MobileDonateButton(props: { campaignId: string }) {
	return (
		<DivWithPrimaryColorVariable className="sticky bottom-0 block p-6 lg:hidden">
			<Gradient className="absolute -z-10" />
			<div className="bg-background rounded-[12px]">
				<Suspense
					fallback={
						<Button size="2xl" className="w-full">
							<Spinner />
						</Button>
					}
				>
					<SuspensedMobileDonateButton campaignId={props.campaignId} />
				</Suspense>
			</div>
		</DivWithPrimaryColorVariable>
	);
}

function SuspensedMobileDonateButton(props: { campaignId: string }) {
	const { portalId } = usePortalContext();
	const { i18n } = useTranslation();
	const campaign = usePortalCampaignQuery(props.campaignId);

	if (isNotFound(campaign)) return null;

	if (campaign.data.finished) {
		return (
			<Button size="2xl" className="w-full" disabled>
				{i18n.portal.campaignFunded}
			</Button>
		);
	}

	return (
		<Button size="2xl" className="w-full" asChild>
			<Link
				to="/$portalId/$campaignId/donate"
				params={{ portalId, campaignId: props.campaignId }}
				search={(prev) => prev}
			>
				{i18n.actions.makeDonation}
			</Link>
		</Button>
	);
}
